module.exports = __webpack_public_path__ + "img/dhdTitle.c2bbfaad.png";